import { render } from "./CookiesRadioButton.vue?vue&type=template&id=5be43b6c&scoped=true&ts=true"
import script from "./CookiesRadioButton.vue?vue&type=script&lang=ts"
export * from "./CookiesRadioButton.vue?vue&type=script&lang=ts"

import "./CookiesRadioButton.vue?vue&type=style&index=0&id=5be43b6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be43b6c"]])

export default __exports__